var map = {
	"./Ellipse.png": "caeb",
	"./Google Logo.svg": "b4ec",
	"./Vector.svg": "e455",
	"./advancedSettings.png": "8b2e",
	"./ans_images.png": "ffb0",
	"./approved.png": "aed0",
	"./clicker.png": "c35c",
	"./downloadIcon.png": "fc89",
	"./draggable.png": "bf96",
	"./export-cloud.svg": "5870",
	"./export.svg": "1578",
	"./eyes.svg": "c269",
	"./folder.png": "16cf",
	"./game.svg": "dfde",
	"./leafArrow.png": "8732",
	"./logo-anim.gif": "25ea",
	"./logout.svg": "69e3",
	"./media.png": "bd63",
	"./openSelector.svg": "76b9",
	"./people-group.svg": "ba5a",
	"./people10.png": "1fd6",
	"./people100.png": "f557",
	"./people200.png": "b992",
	"./people300.png": "98f0",
	"./people50.png": "65a3",
	"./people500.png": "684c",
	"./phone.png": "7f32",
	"./plus.png": "160b",
	"./plus.svg": "eb38",
	"./preview.png": "7077",
	"./question.png": "623c",
	"./questionMark.png": "b8d5",
	"./red_plus.svg": "cec2",
	"./remoteControl.svg": "05c5",
	"./rightArrow.png": "0df7",
	"./screenBase.png": "0390",
	"./search.png": "ccef",
	"./setting.png": "08ba",
	"./statistics.svg": "8ccb",
	"./style.png": "b159",
	"./subject.png": "7288",
	"./survey.png": "5972",
	"./text.png": "d95f",
	"./trash.png": "df33",
	"./trivia.png": "6887",
	"./upload.png": "f599",
	"./uploadGreen.svg": "c00c",
	"./xlsx.png": "7598",
	"./youtube.png": "7702"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d11f";